import { motion } from "motion/react";

export function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-gradient-to-br from-[#051F20] via-[#0B2B26] to-[#163832] py-12 md:py-20 px-4 sm:px-6 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "radial-gradient(circle at 40px 40px, #8EB69B 1%, transparent 1%)",
            backgroundSize: "80px 80px"
          }}
        />
      </div>

      <motion.div
        className="relative mx-auto w-full max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {/* Header Section */}
        <div className="mb-12">
          <div className="flex items-center gap-2 rounded-full border border-[#8EB69B]/30 bg-[#051F20]/60 px-4 py-2 text-xs font-medium text-[#C9A961] uppercase tracking-wider mb-6 w-fit">
            <span className="h-1.5 w-1.5 rounded-full bg-[#C9A961]" />
            Privacy & Data Protection
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 tracking-tight leading-tight block">
            Privacy Policy
          </h1>
          <p className="text-sm text-[#8EB69B] mb-6 font-medium block">
            Kalpakrushi • Effective Date: February 7, 2026
          </p>
          <p className="text-lg md:text-xl text-white/90 leading-relaxed block">
            We respect your privacy and are committed to protecting your personal data. This policy
            explains what we collect, how we use it, and the choices you have.
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          {[
            {
              title: "1. Introduction",
              body:
                `Kalpakrushi ("App," "we," "us," or "our") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your 
                information when you use our smart farming application and website.`,
            },
            {
              title: "2. Information We Collect",
              body:
                `Account Information, Location Data, Usage Data, Device Information, and Images for analysis.`,
            },
            {
              title: "3. How We Use Your Information",
              body:
                `To provide AI-powered advisory, weather updates, market prices, notifications, 
                improve user experience, and comply with legal obligations.`,
            },
            {
              title: "4. Data Sharing & Third Parties",
              body:
                `We may share data with Firebase, weather APIs, market data providers, and AI services 
                strictly for service functionality. We do NOT sell your personal data.`,
            },
            {
              title: "5. Data Security",
              body:
                `We use encryption, secure cloud infrastructure, SSL/TLS, and regular audits to 
                protect your information.`,
            },
            {
              title: "6. Your Rights",
              body:
                `You may access, update, or request deletion of your data, and manage notification 
                preferences within the app.`,
            },
            {
              title: "7. Image & Data Uploads",
              body:
                `Uploaded images are processed by AI for advisory purposes and may be temporarily 
                retained for service improvement.`,
            },
            {
              title: "8. Children’s Privacy",
              body:
                `Kalpakrushi is not intended for users under 13. We do not knowingly collect data 
                from children.`,
            },
            {
              title: "9. Contact Us",
              body:
                `For privacy-related concerns, contact us at kalpakrushi@gmail.com.`,
            },
            {
              title: "10. Policy Updates",
              body:
                `We may update this policy periodically. Continued use signifies acceptance of changes.`,
            },
          ].map((section, i) => (
            <div
              key={i}
              className="group bg-white/5 border border-[#8EB69B]/15 rounded-xl p-6 md:p-7 backdrop-blur-sm transition-all duration-300 hover:border-[#8EB69B]/30 hover:bg-white/8"
            >
              <div className="flex items-start gap-3">
                <span className="h-2.5 w-2.5 rounded-full bg-[#8EB69B] flex-shrink-0 mt-1" />
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-semibold text-white mb-3 block">
                    {section.title}
                  </h2>
                  <div className="text-white/90 text-base md:text-lg leading-relaxed block">
                    {section.body}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-[#8EB69B]/15 text-sm text-white text-center">
          © 2026 Kalpakrushi AgriTech. All rights reserved.
        </div>
      </motion.div>
    </main>
  );
}
